export function convertBase64ToImage(base64Data, cb) {
  fetch(base64Data)
    .then((res) => res.blob())
    .then((blob) => {
      cb(blob);
      return blob;
    });
}
